import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Users, Heart } from "lucide-react";
import { api, mediaSrc, fmtCount } from "@/lib/api";
import { Avatar } from "@/components/Layout";

export default function Explore() {
  const [creators, setCreators] = useState([]);
  useEffect(() => { api.get("/creators").then((r) => setCreators(r.data)); }, []);

  return (
    <div className="mx-auto max-w-7xl px-4 py-10 md:px-8 md:py-16">
      <p className="font-mono text-[11px] font-medium uppercase tracking-[0.3em] text-[#FF2E4D]">Explore</p>
      <h1 className="mt-2 font-display text-2xl font-semibold tracking-tight sm:text-3xl">Creators after dark</h1>
      <p className="mt-3 max-w-lg text-sm text-gray-400 md:text-base">Find someone you love, open their page and subscribe in one tap.</p>
      <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="creators-grid">
        {creators.map((c, i) => (
          <Link key={c.id} to={`/u/${c.username}`} data-testid={`creator-card-${c.username}`} style={{ animationDelay: `${i * 70}ms` }}
            className="group rise-in overflow-hidden rounded-md border border-[#2A2E37] bg-[#121418] transition-[transform,border-color] duration-300 hover:-translate-y-1 hover:border-white/25">
            <div className="relative h-36 overflow-hidden bg-[#1C1F26]">
              {c.banner_url && <img src={mediaSrc(c.banner_url)} alt="" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />}
              <div className="absolute inset-0 bg-gradient-to-t from-[#121418] to-transparent" />
            </div>
            <div className="relative -mt-10 px-5 pb-5">
              <Avatar user={c} size="h-20 w-20" className="ring-4 ring-[#121418]" />
              <div className="mt-3 flex items-start justify-between gap-3">
                <div>
                  <h3 className="font-display text-base font-semibold">{c.name}</h3>
                  <p className="text-xs text-gray-500">@{c.username}</p>
                </div>
                <span className="rounded-sm border border-[#2A2E37] bg-[#1C1F26] px-2.5 py-1 font-mono text-xs font-medium text-white">${c.price}/mo</span>
              </div>
              <p className="mt-3 line-clamp-2 text-sm text-gray-300">{c.bio}</p>
              <div className="mt-4 flex gap-4 text-xs text-gray-400">
                <span className="flex items-center gap-1"><Users className="h-3.5 w-3.5" />{fmtCount(c.subscribers_count)} subs</span>
                <span className="flex items-center gap-1"><Heart className="h-3.5 w-3.5" />{fmtCount(c.likes_count)}</span>
                <span>{c.posts_count} posts</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
